import { styled } from "styled-components";

export interface AbsoluteDivProps {
  top?: string;
  right?: string;
  bottom?: string;
  left?: string;
  zIndex?: string;
}

export const AbsoluteDiv = styled.div<AbsoluteDivProps>`
  position: absolute;
  top: ${(props) => props.top};
  right: ${(props) => props.right};
  bottom: ${(props) => props.bottom};
  left: ${(props) => props.left};
  z-index: ${(props) => props.zIndex};
  pointer-events: none;
  touch-action: none;
`;

const CommonLogoContainer = styled.header`
  z-index: 999;
  cursor: pointer;

  @media (max-width: 768px) {
    max-width: 83%;
  }
`;

export const LogoHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  margin-bottom: 32px;
  padding-left: 174px;
  box-sizing: content-box;

  @media (max-width: 768px) {
    justify-content: center;
    margin-bottom: 16px;
    padding: 0px;
  }
`;
export const LogoContainer = styled(CommonLogoContainer)`
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 180px;
  background-color: var(--palette-bg-neutral-base);
  @media (max-width: 1280px) {
    max-width: 130px;
  }
  @media (max-width: 768px) {
    justify-content: center;
    max-width: 100px;
  }
`;

export const CenteredLogoContainer = styled(CommonLogoContainer)`
  margin-top: 20px;
  margin-bottom: 50px;

  @media (max-width: 768px) {
    margin-bottom: inherit;
  }
`;

export const ConnectorIconBorder = styled.span`
  height: var(--sizes-spacing-10);
  width: var(--sizes-spacing-10);
  margin-top: var(--sizes-spacing-1);
  background-color: var(--palette-bg-status-neutral);
  border: 0px solid transparent;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  svg {
    @media (max-width: 640px) {
      width: 44px;
    }
    color: var(--palette-content-neutral-subtle);
  }
`;

export const ConnectorIconContainer = styled.div`
  height: 74px;
  width: 74px;
  display: flex;
  justify-content: center;
  align-items: center;
  /* flyui ConnectionItem sets flex-grow: 1 on its 2nd-to-last div
     child to push actions right; without actions, that targets this
     container and stretches it. */
  flex-grow: 0 !important;
`;
